module.exports = __webpack_public_path__ + "img/David Faulkner.0cf64270.jpg";